'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { cn } from '@/lib/utils';
import Container from '@/components/ui/container';
import Text from '@/components/ui/Text';
import { setAttr } from '@directus/visual-editing';

interface RichTextProps {
	data: {
		id: string;
		content?: string;
		alignment?: 'left' | 'center' | 'right';
		container_width?: 'narrow' | 'full';
	};
	className?: string;
}

const RichText = ({ data, className }: RichTextProps) => {
	const { id, content, alignment = 'left', container_width = 'narrow' } = data;

	const router = useRouter();

	useEffect(() => {
		const container = document.querySelector('.prose');
		const links = container?.querySelectorAll('a');

		links?.forEach((link) => {
			const href = link.getAttribute('href');
			if (href && href.startsWith('/')) {
				link.onclick = (event) => {
					event.preventDefault();
					router.push(href);
				};
			}
		});

		const iframes = container?.querySelectorAll('iframe');
		iframes?.forEach((iframe) => {
			const wrapper = document.createElement('div');
			wrapper.className = 'relative aspect-video';
			iframe.parentNode?.insertBefore(wrapper, iframe);
			wrapper.appendChild(iframe);

			iframe.style.position = 'absolute';
			iframe.style.top = '0';
			iframe.style.left = '0';
			iframe.style.width = '100%';
			iframe.style.height = '100%';
		});
	}, [content, router]);

	return (
		<section className="py-16">
			<Container>
				<div
					className={cn(
						container_width === 'full' ? 'max-w-full px-4 md:px-8 lg:px-12' : 'max-w-4xl',
						'space-y-6',
						alignment === 'center' ? 'mx-auto text-center' : 'mx-auto text-left', // Block alignment
						className,
					)}
				>
					{content && (
						<Text
							content={content}
							className={alignment === 'center' ? 'mx-auto max-w-none' : 'max-w-none'}
							data-directus={setAttr({
								collection: 'block_richtext',
								item: id,
								fields: 'content',
								mode: 'drawer',
							})}
						/>
					)}
				</div>
			</Container>
		</section>
	);
};

export default RichText;
